import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock } from "lucide-react";
import { motion } from "framer-motion";
import { toast } from "sonner";

export default function AdminLogin() {
  const [pwd, setPwd] = useState("");
  const navigate = useNavigate();
  const onSubmit = (e) => {
    e.preventDefault();
    if (pwd === "admin123") {
      sessionStorage.setItem("fmi-admin", "1");
      toast.success("Authenticated");
      navigate("/admin");
    } else {
      toast.error("Wrong password");
    }
  };
  return (
    <div className="relative min-h-screen flex items-center justify-center px-6 bg-background">
      <div className="absolute inset-0 pointer-events-none" style={{ background: "radial-gradient(60% 50% at 50% 30%, rgba(139,92,246,0.18), rgba(10,10,15,0) 70%)" }} />
      <motion.form initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} onSubmit={onSubmit} className="relative w-full max-w-md rounded-2xl border border-border/70 bg-card/80 backdrop-blur-md p-8">
        <Lock className="h-5 w-5 text-primary" />
        <h1 className="mt-4 text-2xl font-medium">Admin access</h1>
        <p className="text-sm text-muted-foreground mt-1">Restricted to site owner.</p>
        <div className="mt-8">
          <label className="font-mono text-[10px] tracking-[0.22em] uppercase text-muted-foreground">Password</label>
          <input type="password" value={pwd} onChange={(e) => setPwd(e.target.value)} className="mt-2 w-full bg-transparent border-b border-primary/60 focus:border-primary outline-none py-3 text-[15px]" />
        </div>
        <button type="submit" className="mt-7 w-full h-11 rounded-full bg-primary text-primary-foreground font-mono text-[12px] tracking-[0.22em] uppercase hover:bg-primary/90">Enter</button>
        <p className="font-mono text-[10px] text-muted-foreground mt-4">dev password: admin123 — replace with backend JWT auth before deploy.</p>
      </motion.form>
    </div>
  );
}
